module.exports = __webpack_public_path__ + "static/media/instruments.ada7c781.svg";